export default __webpack_public_path__ + "static/media/facebook.1526b975.svg";